export default __webpack_public_path__ + "static/media/Victory_1.acd3acc1.svg";